<template>
    <section class="assessmentSection questionsSection">
        <div class="pageContent">

            <!-- WHEN ROOM SELECTED -->
            <header class="sectionHeader">
                <div class="pageTitle">Tell us about the {{ areaOfConcern.name }}</div>
            </header>

            <AocView>
                <section class="addingSection aocEvaluationSection">
                <!-- Accessible from the ground floor -->
                <div class="choiceSelector horizontal"
                     v-if="areaOfConcern.name">
                    <div class="choiceSelector-title">Is this room accessible from the ground floor?</div>
                    <div class="choiceSelections">
                        <div v-for="option in accessibleFromGroundFloorOptions"
                             class="choiceSelection"
                             :class="{'selected': areaOfConcern.accessibleFromGroundFloor == option.value}"
                             @click="setWindowsAccessibleFromGroundFloor(option.value)">
                            {{ option.label }}
                        </div>
                    </div>
                    <div v-if="areaOfConcern.accessibleFromGroundFloor == false && !areaOfConcern.accessOverride">
                        <p>
                            <strong>Unaccessible windows generally don't require protection</strong>
                            <br> If you can’t reach the window then a burglar probably can’t either.
                        </p>

                        <a href="javascript:;"
                           @click="accessOverride">I'd still like to add window protection</a>
                    </div>
                </div>

                <!-- How many windows in room -->
                <transition name="fade">
                    <div class="choiceSelector horizontal"
                         v-if="windowQtyVisible">
                        <div class="choiceSelector-title">How many windows are in this room?</div>
                        <div class="incrementor">
                            <div class="incrementor-down"
                                 @click="decrementWindows"><span>-</span></div>
                            <div class="incrementor-value">{{ areaOfConcern.windows }}</div>
                            <div class="incrementor-up"
                                 @click="incrementWindows"><span>+</span></div>
                        </div>
                    </div>
                </transition>

                <!-- How many windows open -->
                <transition name="fade">
                    <div class="choiceSelector horizontal"
                         v-if="windowQtyOpenVisible">
                        <div class="choiceSelector-title">How many of those windows open?</div>
                        <div class="incrementor">
                            <div class="incrementor-down"
                                 @click="decrementWindowsThatOpen"><span>-</span></div>
                            <div class="incrementor-value">{{ areaOfConcern.windowsThatOpen }}</div>
                            <div class="incrementor-up"
                                 @click="incrementWindowsThatOpen"><span>+</span></div>
                        </div>
                    </div>
                </transition>

                <transition name="fade">
                    <button class="button full"
                            @click="next"
                            v-if="areaOfConcern.windows">See options</button>
                </transition>

                <transition name="fade">
                    <button class="button full"
                            @click="resetArea"
                            v-if="areaOfConcern.accessibleFromGroundFloor === false && !areaOfConcern.accessOverride">
                        Done
                    </button>
                </transition>


            </section>
            </AocView>
        </div>
    </section>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import AocView from '../../components/AocView.vue'
export default {
    components: {
        AocView
    },
    data() {
        return {
            accessibleFromGroundFloorOptions: [
                {
                    label: 'Yes',
                    value: true
                },
                {
                    label: 'No',
                    value: false
                }
            ],
        }
    },
    computed: {
        ...mapState(['areaOfConcern', 'emptyAreaOfConcern']),

        windowQtyVisible() {
            let accessible = this.areaOfConcern.accessibleFromGroundFloor
            let accessOverride = this.areaOfConcern.accessOverride
            return accessible || accessOverride
        },

        windowQtyOpenVisible() {
            let accessible = this.areaOfConcern.accessibleFromGroundFloor
            let accessOverride = this.areaOfConcern.accessOverride
            let hasWindowQty = this.areaOfConcern.windows > 0

            if (accessible && hasWindowQty) {
                return true
            }

            if (!accessible && accessOverride && hasWindowQty) {
                return true
            }

            return false
        },

        windowOpenOptions() {
            let options = []
            let windows =
                this.areaOfConcern.windowsInput || this.areaOfConcern.windows
            if (windows < 4) {
                for (var index = 0; index < windows; index++) {
                    let number = index + 1
                    options.push({
                        label: number,
                        value: number
                    })
                }
                return options
            }

            return this.windowOptions
        }
    },
    methods: {
        ...mapActions([
            'updateAreaOfConcern', 
            'restrictToUnsignedInteger',
            'incrementAocSectionIndex',
            'decrementAocSectionIndex',
            'setAocSectionIndex'
        ]),

        next() {
            this.updateAreaOfConcern(this.areaOfConcern)
            this.incrementAocSectionIndex()
        },

        resetArea() {
            // Empty the local area of concern
            this.updateAreaOfConcern(this.emptyAreaOfConcern)
            this.setAocSectionIndex(-1)
        },

        incrementWindows() {
            return this.$store.state.areaOfConcern.windows++
        },
        decrementWindows() {
            if (this.$store.state.areaOfConcern.windows > 0) {
                this.$store.state.areaOfConcern.windows--
                if (this.$store.state.areaOfConcern.windowsThatOpen > this.$store.state.areaOfConcern.windows) {
                    this.$store.state.areaOfConcern.windowsThatOpen = this.$store.state.areaOfConcern.windows
                }
            }
        },
        decrementWindowsThatOpen() {
            if (this.$store.state.areaOfConcern.windowsThatOpen > 0) {
                return this.$store.state.areaOfConcern.windowsThatOpen--
            }
        },
        incrementWindowsThatOpen() {
            if (this.$store.state.areaOfConcern.windowsThatOpen < this.$store.state.areaOfConcern.windows) {
                return this.$store.state.areaOfConcern.windowsThatOpen++
            }
        },

        setWindowsAccessibleFromGroundFloor(value) {
            this.updateAreaOfConcern({
                accessibleFromGroundFloor: value
            })
        },

        addWindowsToRoom(number) {
            this.updateAreaOfConcern({
                windows: number
            })
            this.addWindowsThatOpenToRoom(0)
        },

        addWindowsThatOpenToRoom(number) {
            this.updateAreaOfConcern({
                windowsThatOpen: number
            })
        },

        accessOverride(type) {
            this.updateAreaOfConcern({
                accessOverride: true,
                equipmentOptionChosen: ''
            })

            if (type == 'analyzed') {
                this.updateAreaOfConcern({
                    accessOverride: true,
                    analyzed: false
                })
            }
        }
    }
}
</script>

<style lang="css"></style>

